import React from 'react';
import EventGroup from './EventGroup.js';
import { withNamespaces } from 'react-i18next';


const EventsList = (props) => {
  const { t, past, present, future } = props;

  return (
    <div>
      <div className='rtxPresentEvents'>
        <EventGroup data={present} title={t('public:event_groups.active')}/>
      </div>
      <div className='rtxFutureEvents'>
        <EventGroup data={future} title={t('public:event_groups.future')}/>
      </div>
      <div className='rtxPastEvents'>
        <EventGroup data={past} title={t('public:event_groups.past')}/>
      </div>
    </div>
  );
};

export default withNamespaces('public')(EventsList);



// WEBPACK FOOTER //
// ./src/public/components/EventsList/index.js